import { matchPath } from 'react-router';
import { FormTokenNode } from '../../../types/context';

// Walks the form token chain to its root; returns the root pathname when it is a
// standalone form route (/form/:formId/add), else undefined. Pure — token accessors injected.
export const getStandaloneRootFormPath = (
  actualToken: FormTokenNode | null,
  getToken: (id: string) => FormTokenNode | null,
  formAddActionPath: string
): string | undefined => {
  let token = actualToken;

  while (token?.parentTokenId) {
    const parent = getToken(token.parentTokenId);
    if (!parent) {
      break;
    }
    token = parent;
  }

  if (!token) {
    return undefined;
  }

  const rootPath = token.url.split('?')[0];
  return matchPath(rootPath, { path: formAddActionPath })
    ? rootPath
    : undefined;
};
